// Core imports
import { Fragment, useState } from 'react';
import classNames from 'classnames';

// Component imports
import { Card, Col, Row, Typography, Space, Button } from 'antd';
import ImportTranslationsForm from '../Forms/ImportTranslationsForm';
import ExportTranslationsForm from '../Forms/ExportTranslationsForm';
import SideModal from '../Layout/SideModal';

// Misc imports
import { t } from 'i18next';
import { MANUAL_TRANSLATION_STEPS } from '../../constants/translations';
import { TranslationsIcon } from '../Icons/TranslationsIcon';
import { ArrowRightLongIcon } from '../Icons/ArrowRightLongIcon';

const ManualTranslationsView = () => {

  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [isImportModalOpen, setIsImportModalOpen] = useState(false);

  const handleCloseImportModal = () => {
    setIsImportModalOpen(false);
  };

  const handleCloseExportModal = () => {
    setIsExportModalOpen(false);
  };

  const onExportClick = () => {
    setIsExportModalOpen(true);
  };

  const onImportClick = () => {
    setIsImportModalOpen(true);
  };

  const getSortedSteps = () => {
    return Object.values(MANUAL_TRANSLATION_STEPS).sort((a, b) => a.priority - b.priority);
  };

  const renderStepCards = () => {
    const stepsArray = getSortedSteps();

    return (
      <Fragment>
        <Row className="pt-4" gutter={[16, 16]}>
          {
            stepsArray.map((step, index) => {
              return (
                <Col className="py-3" xs={24} key={step.key}>
                  {renderStepCard(step)}
                  <ArrowRightLongIcon
                    className={classNames('rotated-90 position-absolute left-20', {
                      'd-none': index === stepsArray.length - 1
                    })}
                    style={{ left: '8.3%', bottom: '-11%' }}
                  />
                </Col>
              );
            })
          }
        </Row>
      </Fragment>
    );
  };

  const renderStepButton = (stepKey) => {
    switch(stepKey) {
      case MANUAL_TRANSLATION_STEPS.STEP_1.key:
        return <Button
          type="primary"
          onClick={onExportClick}
        >
          {t(`Export`)}
        </Button>;
      case MANUAL_TRANSLATION_STEPS.STEP_3.key:
        return <Button
          type="primary"
          onClick={onImportClick}
        >
          {t(`Import`)}
        </Button>;
      default:
        return null;
    }
  };

  const renderStepCard = (stepDetails) => {
    return (
      <Card className="p-0">
        <Row>
          <Col span={4} className="bg-layout border-radius-top-left-base border-radius-bottom-left-base">
            <Space direction="vertical" className="d-flex align-center text-center p-4">
              <Typography.Text className="fs-sm fw-600"> {stepDetails.labelProperties.stepColumn.stepLabel}</Typography.Text>
              <Typography.Text className="fs-base fw-700">{stepDetails.labelProperties.stepColumn.mainLabel}</Typography.Text>
              <Typography.Text className="fs-base">{stepDetails.labelProperties.stepColumn.icon}</Typography.Text>
            </Space>
          </Col>
          <Col span={16}>
            <Space className="p-4" direction="vertical">
              <Typography.Text className="fw-600">{stepDetails.labelProperties.mainColumn.title}</Typography.Text>
              <Typography.Paragraph>{stepDetails.labelProperties.mainColumn.description}</Typography.Paragraph>
            </Space>
          </Col>
          <Col span={4} className="text-center">
            <div className="d-flex align-items-center justify-content-center h-100">
              {renderStepButton(stepDetails.key)}
            </div>
          </Col>
        </Row>
      </Card>
    );
  };

  return (
    <Fragment>
      {renderStepCards()}

      <SideModal
        open={isExportModalOpen}
        onClose={handleCloseExportModal}
        title={<Typography.Text><TranslationsIcon className="mr-2" /> {t('Manual Translations - Export')} </Typography.Text>}
        bodyClassName="p-0"
        destroyOnClose
      >
        <ExportTranslationsForm
          onExportComplete={handleCloseExportModal}
          onCancel={handleCloseExportModal}
        />
      </SideModal>

      <SideModal
        open={isImportModalOpen}
        onClose={handleCloseImportModal}
        title={<Typography.Text><TranslationsIcon className="mr-2" /> {t('Manual Translations - Import')} </Typography.Text>}
        bodyClassName="p-0"
        destroyOnClose
      >
        <ImportTranslationsForm
          onClickNavigateToExport={() => {
            handleCloseImportModal();
            onExportClick();
          }}
          onUpdateComplete={handleCloseImportModal}
          onCancel={handleCloseImportModal}
        />
      </SideModal>
    </Fragment>
  );
};

export default ManualTranslationsView;
